import { Grid, Paper } from "@material-ui/core";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import GoogleReCaptcha from "../../components/GoogleReCaptcha";
import RxButton from "../../components/RxButton";
import RxDialog from "../../components/RxDialog";
import { RxDialogState } from "../../components/RxDialog/RxDialog";
import RxTextField from "../../components/RxTextField";
import RxTypography from "../../components/RxTypography";
import api from "../../config/AxiosConfig";
import { SuccessResponseDTO } from "../../constants/CommonObject";
import styles from "./ForgetPasswordPage.module.css";
import ForgetPasswordPageValidation from "./ForgetPasswordPageValidation";

const ForgetPasswordPage = () => {
	const [dialogState, setDialogState] = useState<RxDialogState>({
		isOpen: false,
	} as RxDialogState);
	const history = useHistory();
	const [googleReCaptchaToken, setGoogleReCaptchaToken] = useState<string>();
	const siteKey = useSelector((state: any) => state.recaptcha.siteKey);

	const formik = useFormik({
		initialValues: {
			email: "",
		},
		validationSchema: ForgetPasswordPageValidation,
		validateOnBlur: true,
		validateOnChange: true,
		onSubmit: () => {
			handleSubmit();
		},
	});

	function handleSubmit() {
		if (googleReCaptchaToken !== undefined) {
			api.post(`/1/users/${formik.values.email}/reset-password`, {
				captcha: googleReCaptchaToken,
			})
				.then((response: SuccessResponseDTO) => {
					setDialogState({
						isOpen: true,
						title: "Bilgilendirme",
						message: response.responseValue,
						status: "info",
					});
				})
				.catch((error: any) => {
					setDialogState({
						isOpen: true,
						title: "Hata",
						message:
							error.response?.data.code +
							" - " +
							error.response?.data.message +
							"\r\nLütfen daha sonra tekrar deneyiniz.",
						status: "error",
					});
				});
		}
	}

	useEffect(() => {
		handleSubmit();
	}, [googleReCaptchaToken]); // eslint-disable-line

	return (
		<>
			<Paper className={styles.mainPaper}>
				<form onSubmit={formik.handleSubmit}>
					<Grid
						container
						spacing={1}
						direction="row"
						justifyContent="center"
						alignItems="center"
						alignContent="center"
					>
						<Grid item xs={12} sm={12}>
							<Grid container spacing={8}>
								<Grid item xs={12} sm={12}>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<RxTypography
												variant="h5"
												align="center"
												label={<>Parolamı Unuttum</>}
											/>
										</Grid>
									</Grid>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<RxTypography
												variant="caption"
												align="left"
												label={
													<>
														Lütfen kayıt olduğunuz e-posta
														adresinizi aşağıdaki metin kutusuna
														yazınız. Parola sıfırlama bağlantısı
														e-posta adresinize gönderilecektir..
													</>
												}
											/>
										</Grid>
									</Grid>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<RxTextField
												fullwidth
												id="email"
												name="email"
												label="E-posta"
												placeholder="E-posta"
												value={formik.values.email}
												onChange={formik.handleChange}
												onBlur={formik.handleBlur}
												required
												error={
													formik.touched.email &&
													Boolean(formik.errors.email)
												}
												helperText={
													formik.touched.email &&
													formik.errors.email
												}
												helperTextStyle={styles.helperTextStyle}
												inputLabelClassName={styles.inputLabel}
											/>
										</Grid>
									</Grid>

									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<RxButton
												fullWidth
												color={"primary"}
												variant="contained"
												label="Parola Sıfırlama E-Postası Gönder"
												type="submit"
												id="submit"
												className={
													styles.changePasswordButtonMargin
												}
											/>
										</Grid>
									</Grid>
									<Grid
										container
										spacing={1}
										className={styles.buttonSeperator}
									>
										<Grid item xs={5} sm={5}>
											<hr />
										</Grid>
										<Grid item xs={2} sm={2}>
											<RxTypography
												variant="caption"
												align="center"
												label={<>YA DA</>}
											/>
										</Grid>
										<Grid item xs={5} sm={5}>
											<hr />
										</Grid>
									</Grid>
									<Grid container spacing={1}>
										<Grid item xs={12} sm={12}>
											<RxButton
												fullWidth
												className={styles.signInButton}
												variant="contained"
												label="Giriş Yap"
												onClick={() => {
													history.push("/login");
												}}
											/>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<GoogleReCaptcha
						siteKey={siteKey}
						setGoogleReCaptchaToken={setGoogleReCaptchaToken}
					/>
				</form>
			</Paper>
			{dialogState.isOpen && (
				<RxDialog
					title={dialogState.title}
					status={dialogState.status}
					maxWidth="md"
					actions={
						<>
							<RxButton
								fullWidth
								label="Tamam"
								color="primary"
								variant="contained"
								onClick={() => {
									setDialogState((prevState: RxDialogState) => {
										return { ...prevState, isOpen: false };
									});
									if (dialogState.status !== "error")
										history.push("/login");
								}}
							/>
						</>
					}
				>
					<RxTypography align="left" label={dialogState.message} />
				</RxDialog>
			)}
		</>
	);
};

export default ForgetPasswordPage;
